export default "__VITE_ASSET__4a882e93__"